const normalizeLanguage = (language?: string) =>
  language?.trim().toLowerCase().split("-")[0] || "";

const getPreferredLanguages = (language: string, fallbackLanguage?: string) =>
  [
    normalizeLanguage(language),
    normalizeLanguage(fallbackLanguage),
    normalizeLanguage(language) === "en" ? "da" : "",
    "en",
    "da",
  ].filter(
    (value, index, languages) => value && languages.indexOf(value) === index
  );

export const resolveLangText = (
  text: unknown,
  language: string,
  fallbackLanguage?: string
): string => {
  if (!text) return "";
  if (typeof text === "string") return text;

  const preferredLanguages = getPreferredLanguages(language, fallbackLanguage);

  if (Array.isArray(text)) {
    const translations = text.filter(
      (value): value is { lang: string; value: string } =>
        typeof value?.lang === "string" && typeof value?.value === "string"
    );

    for (const preferredLanguage of preferredLanguages) {
      const translation = translations.find(
        ({ lang }) => normalizeLanguage(lang) === preferredLanguage
      );
      if (translation?.value.trim()) return translation.value;
    }

    return translations.find(({ value }) => value.trim())?.value || "";
  }

  if (typeof text !== "object") return "";

  const translations = Object.entries(text).filter(
    (entry): entry is [string, string] => typeof entry[1] === "string"
  );

  for (const preferredLanguage of preferredLanguages) {
    const translation = translations.find(
      ([lang, value]) =>
        normalizeLanguage(lang) === preferredLanguage && value.trim()
    );
    if (translation) return translation[1];
  }

  return translations.find(([, value]) => value.trim())?.[1] || "";
};
